import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { initSentry } from './utils/sentry'
import './i18n' // Initialize i18n
import './index.css'

// Initialize Sentry before rendering
initSentry()

// Wrap App with Sentry routing and Error Boundary
const SentryApp = Sentry.withSentryRouting(App)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <SentryApp />
    </ErrorBoundary>
  </React.StrictMode>,
)
